// ============================================
// Detail Module - Scroll (ES6)
// 스크롤 이벤트 처리
// ============================================

// ============================================
// 스크롤 이벤트 초기화
// ============================================

export function initDetailScrollHandler() {
  const detailModal = document.querySelector('.content-detail-modal');
  const detailHeader = document.querySelector('.detail-header');
  if (detailModal && detailHeader) {
    detailModal.addEventListener('scroll', function() {
      if (detailModal.scrollTop > 100) {
        detailHeader.classList.add('scrolled');
      } else {
        detailHeader.classList.remove('scrolled');
      }
    });
  }
}

// 초기화 (DOM 로드 후)
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initDetailScrollHandler);
} else {
  initDetailScrollHandler();
}
